// ACTION TYPES
import { TOGGLE_LOADING } from '../types';

export const loadingToggleAXN = (isLoading) => (dispatch) => {
  dispatch({
    type: TOGGLE_LOADING,
    payload: isLoading,
  });
};
